import { createRouter, createWebHistory } from "vue-router";
import Login from "../components/Login.vue";
import Tab from "../components/Tab.vue";
import ReservationList from "../components/ReservationList.vue";
import Karte from "../components/Karte.vue";
import KarteView from "../components/KarteView.vue";
import Shift from "../components/Shift.vue";
import ShiftEdit from "../components/ShiftEdit.vue";
import AnytimeConsultationHome from "../components/AnytimeConsultationHome.vue";
import AnytimeConsultationList from "../components/AnytimeConsultationList.vue";
import AnytimeConsultationSearch from "../pages/anytime-consultations/answered-search";
import AnytimeConsultation from "../components/AnytimeConsultation.vue";
import AnytimeConsultationView from "../components/AnytimeConsultationView.vue";
import EpdsView from "../components/EpdsView.vue";
import DaytimeAdviceHome from "../components/DaytimeAdviceHome.vue";
import DaytimeAdviceRoom from "../components/DaytimeAdviceRoom.vue";
import DaytimeAdviceSheet from "../components/DaytimeAdviceSheet.vue";
import DaytimeAdviceSearch from "../pages/daytime-advices/search";
import DaytimeAdviceSearchView from "../components/DaytimeAdviceSearchView.vue";
import DaytimeAdviceMonitor from "../components/DaytimeAdviceMonitor.vue";
import DaytimeAdviceSheetView from "../components/DaytimeAdviceSheetView.vue";
import AnytimeConsultationShift from "../components/AnytimeConsultationShift.vue";
import DeveloperPermissionsPage from "../pages/developer-permissions";
import FaceSheetsTop from "../pages/face-sheets-top";
import FaceSheetsDetail from "../pages/face-sheets-detail";

let router = createRouter({
  history: createWebHistory(),
  routes: [{
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/reservations",
    component: Tab,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "night_consultation:access"]
    },
    children: [
      {
        path: "list",
        name: "list",
        component: ReservationList
      },
      {
        path: "karte",
        name: "karte",
        component: Karte
      },
    ]
  },
  // サブウィンドウによる表示
  {
    path: "/reservations/:id",
    name: "karteView",
    component: KarteView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/shifts",
    name: "shift",
    component: Shift,
    meta: {
      requiresAuth: true,
      requiresOperator: true,
      requiredCapabilities: ["app:access", "operator:access"]
    }
  },
  {
    path: "/shifts/edit",
    name: "shiftEdit",
    component: ShiftEdit,
    meta: {
      requiresAuth: true,
      requiresOperator: true,
      requiredCapabilities: ["app:access", "operator:access"]
    }
  },
  {
    path: "/anytime_consultations",
    component: AnytimeConsultationHome,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "anytime_consultation:access"]
    },
    children: [{
      path: "",
      name: "anytimeConsultationList",
      component: AnytimeConsultationList
    },
    {
      path: "/anytime_consultations/search/",
      name: "anytimeConsultationSearch",
      component: AnytimeConsultationSearch
    }]
  },
  {
    path: "/anytime_consultations/:id",
    name: "anytimeConsultation",
    component: AnytimeConsultation,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "anytime_consultation:access"]
    }
  },
  // サブウィンドウによる表示
  {
    path: "/anytime_consultations/view/:id",
    name: "anytimeConsultationView",
    component: AnytimeConsultationView,
    meta: {
      requiresAuth: true
    }
  },
  // サブウィンドウによる表示
  {
    path: "/epds/:id",
    name: "EpdsView",
    component: EpdsView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/daytime_advices",
    component: DaytimeAdviceHome,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "daytime_advice:access"]
    },
    children: [{
      path: "room",
      name: "daytimeAdviceRoom",
      component: DaytimeAdviceRoom,

      children: [{
        path: "sheet/:id",
        name: "daytimeAdviceSheet",
        component: DaytimeAdviceSheet
      }]
    },
    {
      path: "search",
      name: "daytimeAdviceSearch",
      component: DaytimeAdviceSearch
    },
    {
      path: "search/:id",
      name: "daytimeAdviceSearchView",
      component: DaytimeAdviceSearchView
    },
    {
      path: "monitor",
      name: "daytimeAdviceMonitor",
      component: DaytimeAdviceMonitor
    }]
  },
  // サブウィンドウによる表示
  {
    path: "/daytime_advices_sheets/:id",
    name: "daytimeAdviceSheetView",
    component: DaytimeAdviceSheetView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/anytime_consultation_shifts",
    name: "ac_shift",
    component: AnytimeConsultationShift,
    meta: {
      requiresAuth: true,
      requiresOperator: true,
      requiredCapabilities: ["app:access", "operator:access"]
    }
  },
  {
    path: "/developer/permissions",
    name: "developerPermissions",
    component: DeveloperPermissionsPage,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "developer:access"]
    }
  },
  {
    path: "/face_sheets",
    name: "faceSheetsTop",
    component: FaceSheetsTop,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "high_risk:access"]
    }
  },
  {
    path: "/face_sheets/:user_id",
    name: "faceSheetsDetail",
    component: FaceSheetsDetail,
    meta: {
      requiresAuth: true,
      requiredCapabilities: ["app:access", "high_risk:access"]
    }
  },
  ]
});

export default router;
